<template>
    <div>
         <div class="q-pa-md"  >
                <q-list>
                    <q-item v-bind:key="Holding.index" v-for="Holding in StoreStateCD.Transaction.Redemption">

                        <q-item-section  style="border-bottom:1px solid #063ca1">
                        <q-item-label>
                          <div class="row text-center text-caption text-italic text-grey-7">
                            <div class="col" style="border:1px solid #d9dcde"  >
                                  Account Number
                                </div>
                                <div class="col" style="border:1px solid #d9dcde"  >
                                  Fund Name
                                </div>
                                <div class="col" style="border:1px solid #d9dcde" >
                                    Unit Redeem
                                </div>
                                <div class="col" style="border:1px solid #d9dcde"  >
                                  Payment Instruction 
                                </div>
                                 <div class="col" style="border:1px solid #d9dcde"  >
                                  Cut Off Time 
                                </div>
                                <div class="col" style="border:1px solid #d9dcde"  v-if="Holding.doclink !=''" >
                                  Prospectus 
                                </div>
                            </div>
                            <div class="row text-center">
                              <div class="col" style="border:1px solid #d9dcde">
                                    {{Holding.accountId}}
                                </div>
                                <div class="col" style="border:1px solid #d9dcde">
                                    {{Holding.FundName}}
                                </div>
                                <div class="col" style="border:1px solid #d9dcde" >
                                  {{formatthousandseparator(Holding.Units.toFixed(2))}}   
                                 </div>
                                <div class="col" style="border:1px solid #d9dcde"  >
                                 {{Holding.PaymentInstruction}}
                                </div>
                                <div class="col" style="border:1px solid #d9dcde"  >
                                 {{Holding.cutOffTime}}
                                </div>
                                 <div class="col" style="border:1px solid #d9dcde" v-if="Holding.doclink !=''" >
                                  <q-chip square clickable  style="font-size:12px;" color="primary" text-color="white"  @click="openProspectus(Holding.doclink)" icon="fas fa-file-download">
                                     Download
                                  </q-chip>
                                </div>
                              </div>
                            
                            </q-item-label>
                            </q-item-section> 
                    </q-item>
                </q-list>
            </div>
    </div>
</template>



<script>
import store from '../../../store';
import {VMoney, Money} from 'v-money'
import { date } from 'quasar';
import { mapActions } from 'vuex'
export default {
  name: 'TransactionsRedemptionPRS',
  components: {
    Money,
  },
  data () {
    return {
        StoreStateCD : store.state.CD,
        StoreStateT: store.state.Transactions,
        Data : '',
        TransactionId : '',
        
        PaymentInstructionOptions : [],
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false /* doesn't work with directive */
        },
    }
  }, filters: {
		thousandSeparator: function(value) {
			if (value !== undefined) {
				return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			} else {
				return value;
			}
		}
  },
  mounted(){
 /*    this.GetUserAccountHolding()
    .then(res=>{
        if(res==='error'){
            this.$q.dialog({
                title: 'Error',
                message: 'Something went wrong. Please contact your administrator.',
            })    
        }
        else{
          
        }
      }) */
  },
  methods : {
    ...mapActions([
      "PostTransaction",
      "GetUserAccountHolding",
    ]),

    openProspectus:function(obj){
        window.open(obj);
    },

    Cancel(){
      this.$router.go(-1)
    },
    AddToCart(){
      this.CreateTempId();
      this.CreateFundTransaction_Redemption();
      this.PostTransaction({
          ApplicationId : this.StoreStateCD.FormDetails.ApplicationId
      })
      .then(res=>{
        if(res==='error'){
            this.$q.dialog({
                title: 'Error',
                message: 'Something went wrong. Please contact your administrator.',
            })    
        }
        else{
            this.$router.go(-1)
        }
      })
    },
    CreateTempId() {
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (dt + Math.random()*16)%16 | 0;
          dt = Math.floor(dt/16);
          return (c=='x' ? r :(r&0x3|0x8)).toString(16);
        });
        this.TransactionId =  uuid;
    },
    CreateFundTransaction_Redemption(){
      this.StoreStateCD.Transaction.Redemption.push({
        Id: this.TransactionId,
        AmountOrUnit: this.$refs.refFTR.Form.AmountUnits,
        TypeOfProduct: this.StoreStateCD.Account.AccountType,
        FundID: this.Data.Scheme,
        SchemeName : this.Data.ProductName,
        Amount: parseFloat(this.$refs.refFTR.Form.Amount.replace(',','')).toFixed(2),
        PaymentInstruction: this.$refs.refFTR.Form.PaymentMethod.value,
        BankAccountNumber: this.$refs.refFTR.Form.PaymentInstruction.value,
        BankMICRCode : this.$refs.refFTR.Form.PaymentInstruction.MICRCode,
        PayeeName: this.$refs.refFTR.Form.PayeeName,
        Plan: this.$refs.refFTR.Form.Plan,
        Units: this.$refs.refFTR.Form.Units,
        FundCurrency: this.Data.Currency,
        RedeemAll : this.$refs.refFTR.Form.RedeemAllUnits,
        PRSWithdrawalReason : this.$refs.refFTR.Form.PRSWithdrawalReason.value,
        NAV : this.Data.NAV,
        NAVDate : this.Data.NAVDate,
        InitialUnits : this.Data.BalanceUnit,
        InitialAmount : this.Data.Amount 
      })
    },
     formatthousandseparator(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },

 
}
</script>

<style>
.schemeName>.q-field>.q-field__inner>.q-field__control>.q-field__control-container>.q-field__native {
    color: #2f56e2;
    font-weight: 600;
}

.q-field>.q-field__inner>.q-field__control>.q-field__control-container>.q-field__native>.q-field__native {
    text-align: right;
     color: #2f56e2;
    font-weight: 600;
}

.redemptionTxt{
  color: #2f56e2 !important;
    font-weight: 600;
}
</style>